module.exports = __webpack_public_path__ + "media/corporate-image/tachikawalogo-black-removebg-e770a8733eabd48b877fb62811d8817b.png";